module.exports = __webpack_public_path__ + "static/media/3.a399c40c.jpg";